import { Button, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { ReloadOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { PreloadOverlayWrapper, PreloadOverlayCard, PreloadOverlayActions } from '@/pages/style';
import { hardReloadApp } from '@utils/appHardReload';

const { Title, Paragraph, Text } = Typography;

const PreloadErrorOverlay = () => {
    const [visible, setVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const handlePreloadError = (event) => {
            const message = event?.detail?.message || event?.payload?.message || '';
            setErrorMessage(message);
            setVisible(true);
        };

        window.addEventListener('vite:preloadError', handlePreloadError);

        return () => {
            window.removeEventListener('vite:preloadError', handlePreloadError);
        };
    }, []);

    const handleReload = () => {
        void hardReloadApp();
    };

    if (!visible) {
        return null;
    }

    return (
        <PreloadOverlayWrapper>
            <PreloadOverlayCard>
                <Title level={3}>Update Available</Title>
                <Paragraph>
                    We detected a new version of the application but the browser could not preload it automatically.
                    Reload to continue with the latest experience.
                </Paragraph>
                {errorMessage ? <Text type="secondary">{errorMessage}</Text> : null}
                <PreloadOverlayActions>
                    <Button type="primary" size="large" icon={<ReloadOutlined />} onClick={handleReload}>
                        Reload Now
                    </Button>
                    <Button size="large" icon={<CloseCircleOutlined />} onClick={() => setVisible(false)}>
                        Dismiss
                    </Button>
                </PreloadOverlayActions>
            </PreloadOverlayCard>
        </PreloadOverlayWrapper>
    );
};

export default PreloadErrorOverlay;
